module.exports = __webpack_public_path__ + "img/TechStablesHorseshoes_ua.b97a3340.webp";